import React, { FC } from 'react';

interface HelpCircleProps {
  width?: string;
  height?: string;
  color?: string;
  strokeWidth?: string;
}

const SVGHelpCircle: FC<HelpCircleProps> = ({
  width = '25',
  height = '24',
  color = 'black',
  strokeWidth = '2',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.58997 8.99959C9.82507 8.33126 10.2891 7.7677 10.8999 7.40873C11.5107 7.04975 12.2289 6.91853 12.9271 7.0383C13.6254 7.15808 14.2588 7.52112 14.715 8.06312C15.1713 8.60512 15.421 9.29112 15.42 9.99959C15.42 11.9996 12.42 12.9996 12.42 12.9996"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 17H12.51"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SVGHelpCircle;
